import { mount } from '../dom-lifecycle';

/*
	„Posiadam fakturę imienną zamiast paragonu” wyłącza unikalny numer kasy fiskalnej —
	faktura go nie ma. Makieta mówi o tym przypisem „*nie obowiązuje w przypadku faktury
	imiennej”, więc pole ukrywamy razem z etykietą, a nie tylko wygaszamy.

	Serwer pilnuje tego samego niezależnie: `_enabled_if` na `personalData.billPos`
	w config/packages/workflow.yaml wyrzuca pole z formularza, gdy checkbox jest zaznaczony.
	Tutaj chodzi wyłącznie o to, żeby użytkownik nie walczył z polem, którego nie wypełni.

	`disabled` jest ważniejsze niż samo ukrycie: pole `hidden` dalej brałoby udział
	w walidacji HTML5 (`required`), a przeglądarka nie umie pokazać komunikatu przy
	niewidocznym polu i wysyłka cicho by nie przechodziła.
*/

const CHECKBOX = '#personal_data_billInvoice';
const FIELD = '#personal_data_billPos';

function apply(checkbox) {
    const field = document.querySelector(FIELD);
    if (!field) return;

    const row = field.closest('.form-group');
    const isInvoice = checkbox.checked;

    field.disabled = isInvoice;
    if (isInvoice) {
        field.value = '';
        field.classList.remove('is-invalid');
    }
    if (row) row.hidden = isInvoice;
}

mount(CHECKBOX, (checkbox) => {
    apply(checkbox);
    checkbox.addEventListener('change', () => apply(checkbox));
    // po resecie formularza checkbox wraca do stanu domyślnego dopiero po zdarzeniu
    if (checkbox.form) {
        checkbox.form.addEventListener('reset', () => setTimeout(() => apply(checkbox)));
    }
});
